import httpClient from "@/core/axios";

export default function(instance) {
    instance.extend({
        uploader: async function(file, progress, error, options) {
            try {
                const formData = new FormData();
                formData.append("file", file);

                return httpClient.post(options.uploadUrl, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: progressEvent => {
                        progress(
                            Math.round(
                                (progressEvent.loaded * 100) /
                                    progressEvent.total
                            )
                        );
                    }
                });
            } catch (err) {
                error("Unable to upload file");
            }
        },
        uploadUrl: "/api/guest/upload"
    });
}
